import React from 'react';
import { useTranslator } from 'tradera-lang/translate';
import 'tradera-components/item-card/layout.scss';
import './favourite-sellers.scss';
import { useIsFeatureEnabled } from 'tradera-hooks/use-is-feature-enabled';
import { FavouriteSellerCardsGrid } from './favourite-seller-cards-grid';

export const SellerSuggestions = ({ sellerSuggestions }) => {
    const { t } = useTranslator();
    const isSellerSuggestionsEnabled = useIsFeatureEnabled(
        'seller-suggestions'
    );

    if (!isSellerSuggestionsEnabled || !sellerSuggestions?.length) {
        return null;
    }

    return (
        <section className="pt-5">
            <h3 className="start-page-section-title">
                {t('startPage_favouriteSellers_suggestionsTitle')}
            </h3>
            <FavouriteSellerCardsGrid
                sellers={sellerSuggestions}
                isSuggestion={true}
            />
        </section>
    );
};
